import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { spaceProp } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled, { css } from 'styled-components';
import { getColumnCount } from './helpers/getColumnCount.js';
import { getColumnGap } from './helpers/getColumnGap.js';

const StyledList = styled.ul `
  ${({ columns }) => columns && getColumnCount(columns)};
  ${({ columnsSpace }) => columnsSpace && getColumnGap(columnsSpace)};
  width: auto;
  margin: 0;
  padding: 0;
  display: flex;
  ${({ spaceAfter }) => spaceAfter &&
    css `
      ${spaceProp(spaceAfter, 'marginBottom')};
    `};

  ${({ spaceBetween, direction }) => direction === 'vertical' &&
    css `
      flex-direction: column;
      ${spaceBetween && css `
        > li {;
          ${spaceProp(spaceBetween, 'marginBottom')};
        }
      `}
    `};

  ${({ spaceBetween, direction }) => direction === 'horizontal' &&
    css `
      flex-direction: row;
      ${spaceBetween && css `
        > li {
          ${spaceProp(spaceBetween, 'marginRight')};
        }
      `}
    `};
`;
const List = withExtra((_a, ref) => {
    var { spaceAfter, children, className, spaceBetween, direction, columns, columnsSpace } = _a, rest = __rest(_a, ["spaceAfter", "children", "className", "spaceBetween", "direction", "columns", "columnsSpace"]);
    return (React.createElement(StyledList, Object.assign({ spaceAfter: spaceAfter, direction: direction, spaceBetween: spaceBetween, className: className, ref: ref, columns: columns, columnsSpace: columnsSpace }, rest), children));
}, { name: 'List', memo: true });
List.defaultProps = {
    direction: 'vertical',
};

export { List };
//# sourceMappingURL=List.js.map
